export const openSearch = {
    namespaced: true,
    state: {
        data: {
            query: ''
        },
        redirect: false
    },

    getters: {
        getQuery(state) {
            return state.data.query
        },

        getRedirect(state) {
            return state.redirect
        }
    },

    mutations: {
        SET_QUERY(state, payload){
            state.data.query = payload
        },

        SET_REDIRECT(state, payload){
            state.redirect = payload
        }
    },

    actions: {
        /**
         * Seta no state o termo a ser pesquisado pelo OpenSearch
         * 
         * @param {*} param0 
         * @param {String} payload Termo a ser buscado
         */
        setQuery({ commit }, payload) {
            commit('SET_QUERY', payload)
        },

        /**
         * Seta no state se o modal do OpenSearch permite ser fechado
         * 
         * @param {*} param0 
         * @param {Boolean} payload Parâmetro indicando se o modal pode ser fechado
         */
        setRedirect({ commit }, payload) {
            commit('SET_REDIRECT', payload)
        }
    }
}